export default [
    {
        "code": "AF",
        "name": "Afghanistan"
    },
    {
        "code": "AL",
        "name": "Albania"
    },
    {
        "code": "DZ",
        "name": "Algerie"
    },
    {
        "code": "AS",
        "name": "Amerikansk Samoa"
    },
    {
        "code": "VI",
        "name": "Amerikanske Virginøyer"
    },
    {
        "code": "AD",
        "name": "Andorra"
    },
    {
        "code": "AO",
        "name": "Angola"
    },
    {
        "code": "AI",
        "name": "Anquilla"
    },
    {
        "code": "AQ",
        "name": "Antarktis"
    },
    {
        "code": "AG",
        "name": "Antigua og Barbuda"
    },
    {
        "code": "AR",
        "name": "Argentina"
    },
    {
        "code": "AM",
        "name": "Armenia"
    },
    {
        "code": "AW",
        "name": "Aruba"
    },
    {
        "code": "AU",
        "name": "Australia"
    },
    {
        "code": "AZ",
        "name": "Azerbajdzjan"
    },
    {
        "code": "BS",
        "name": "Bahamas"
    },
    {
        "code": "BH",
        "name": "Bahrain"
    },
    {
        "code": "BD",
        "name": "Bangladesh"
    },
    {
        "code": "BB",
        "name": "Barbados"
    },
    {
        "code": "BE",
        "name": "Belgia"
    },
    {
        "code": "BZ",
        "name": "Belize"
    },
    {
        "code": "BJ",
        "name": "Benin"
    },
    {
        "code": "BM",
        "name": "Bermuda"
    },
    {
        "code": "BT",
        "name": "Bhutan"
    },
    {
        "code": "BO",
        "name": "Bolivia"
    },
    {
        "code": "BA",
        "name": "Bosnia-Hercegovina"
    },
    {
        "code": "BW",
        "name": "Botswana"
    },
    {
        "code": "BV",
        "name": "Bouvetøya"
    },
    {
        "code": "BR",
        "name": "Brasil"
    },
    {
        "code": "VG",
        "name": "Britiske Virginøyer"
    },
    {
        "code": "BN",
        "name": "Brunei"
    },
    {
        "code": "BG",
        "name": "Bulgaria"
    },
    {
        "code": "BF",
        "name": "Burkina Faso"
    },
    {
        "code": "BI",
        "name": "Burundi"
    },
    {
        "code": "CA",
        "name": "Canada"
    },
    {
        "code": "KY",
        "name": "Caymanøyene"
    },
    {
        "code": "IO",
        "name": "Chagosøyene"
    },
    {
        "code": "CL",
        "name": "Chile"
    },
    {
        "code": "CX",
        "name": "Christmasøya"
    },
    {
        "code": "CC",
        "name": "Cocosøyene"
    },
    {
        "code": "CO",
        "name": "Colombia"
    },
    {
        "code": "KM",
        "name": "Comorene"
    },
    {
        "code": "CR",
        "name": "Costa Rica"
    },
    {
        "code": "CU",
        "name": "Cuba"
    },
    {
        "code": "DK",
        "name": "Danmark"
    },
    {
        "code": "DJ",
        "name": "Djibouti"
    },
    {
        "code": "DM",
        "name": "Dominica"
    },
    {
        "code": "DO",
        "name": "Dominikanske republikk"
    },
    {
        "code": "EC",
        "name": "Ecuador"
    },
    {
        "code": "EG",
        "name": "Egypt"
    },
    {
        "code": "GQ",
        "name": "Ekvatorial Guinea"
    },
    {
        "code": "SV",
        "name": "El Salvador"
    },
    {
        "code": "CI",
        "name": "Elfenbenkysten"
    },
    {
        "code": "ER",
        "name": "Eritrea"
    },
    {
        "code": "EE",
        "name": "Estland"
    },
    {
        "code": "ET",
        "name": "Etiopia"
    },
    {
        "code": "FK",
        "name": "Falklandsøyene"
    },
    {
        "code": "FJ",
        "name": "Fiji"
    },
    {
        "code": "PH",
        "name": "Filippinene"
    },
    {
        "code": "FI",
        "name": "Finland"
    },
    {
        "code": "AE",
        "name": "Forente Arabiske Emirater"
    },
    {
        "code": "FR",
        "name": "Frankrike"
    },
    {
        "code": "GF",
        "name": "Fransk Guiana"
    },
    {
        "code": "PF",
        "name": "Fransk Polynesia"
    },
    {
        "code": "TF",
        "name": "French Southern Territories"
    },
    {
        "code": "FO",
        "name": "Færøyene"
    },
    {
        "code": "GA",
        "name": "Gabon"
    },
    {
        "code": "GM",
        "name": "Gambia"
    },
    {
        "code": "GE",
        "name": "Georgia"
    },
    {
        "code": "GH",
        "name": "Ghana"
    },
    {
        "code": "GI",
        "name": "Gibraltar"
    },
    {
        "code": "GD",
        "name": "Grenada"
    },
    {
        "code": "GL",
        "name": "Grønland"
    },
    {
        "code": "GP",
        "name": "Guadeloupe"
    },
    {
        "code": "GU",
        "name": "Guam"
    },
    {
        "code": "GT",
        "name": "Guatemala"
    },
    {
        "code": "GG",
        "name": "Guernsey Channel Islands"
    },
    {
        "code": "GN",
        "name": "Guinea"
    },
    {
        "code": "GW",
        "name": "Guinea-Bissau"
    },
    {
        "code": "GY",
        "name": "Guyana"
    },
    {
        "code": "HT",
        "name": "Haiti"
    },
    {
        "code": "HM",
        "name": "Heard og Mc Donald Islands"
    },
    {
        "code": "GR",
        "name": "Hellas"
    },
    {
        "code": "CK",
        "name": "Herveyøyene (Cook Islands)"
    },
    {
        "code": "HN",
        "name": "Honduras"
    },
    {
        "code": "HK",
        "name": "Hong Kong"
    },
    {
        "code": "BY",
        "name": "Hviterussland"
    },
    {
        "code": "IN",
        "name": "India"
    },
    {
        "code": "ID",
        "name": "Indonesia"
    },
    {
        "code": "IQ",
        "name": "Irak"
    },
    {
        "code": "IR",
        "name": "Iran"
    },
    {
        "code": "IE",
        "name": "Irland"
    },
    {
        "code": "IS",
        "name": "Island"
    },
    {
        "code": "IM",
        "name": "Isle of Man"
    },
    {
        "code": "IL",
        "name": "Israel"
    },
    {
        "code": "IT",
        "name": "Italia"
    },
    {
        "code": "JM",
        "name": "Jamaica"
    },
    {
        "code": "JP",
        "name": "Japan"
    },
    {
        "code": "JE",
        "name": "Jersey"
    },
    {
        "code": "JO",
        "name": "Jordan"
    },
    {
        "code": "CM",
        "name": "Kamerun"
    },
    {
        "code": "KH",
        "name": "Kampuchea"
    },
    {
        "code": "CV",
        "name": "Kapp Verde"
    },
    {
        "code": "KZ",
        "name": "Kazakhstan"
    },
    {
        "code": "KE",
        "name": "Kenya"
    },
    {
        "code": "CN",
        "name": "Kina"
    },
    {
        "code": "KI",
        "name": "Kiribati"
    },
    {
        "code": "CG",
        "name": "Kongo"
    },
    {
        "code": "HR",
        "name": "Kroatia"
    },
    {
        "code": "KW",
        "name": "Kuwait"
    },
    {
        "code": "CY",
        "name": "Kypros"
    },
    {
        "code": "KG",
        "name": "Kyrgyzstan"
    },
    {
        "code": "LA",
        "name": "Laos"
    },
    {
        "code": "LV",
        "name": "Latvia"
    },
    {
        "code": "LS",
        "name": "Lesotho"
    },
    {
        "code": "LB",
        "name": "Libanon"
    },
    {
        "code": "LR",
        "name": "Liberia"
    },
    {
        "code": "LY",
        "name": "Libya"
    },
    {
        "code": "LI",
        "name": "Lichtenstein"
    },
    {
        "code": "LT",
        "name": "Litauen"
    },
    {
        "code": "LU",
        "name": "Luxembourg"
    },
    {
        "code": "MO",
        "name": "Macau"
    },
    {
        "code": "MG",
        "name": "Madagaskar"
    },
    {
        "code": "MK",
        "name": "Makedonia"
    },
    {
        "code": "MW",
        "name": "Malawi"
    },
    {
        "code": "MY",
        "name": "Malaysia"
    },
    {
        "code": "MV",
        "name": "Maldivene"
    },
    {
        "code": "ML",
        "name": "Mali"
    },
    {
        "code": "MT",
        "name": "Malta"
    },
    {
        "code": "MA",
        "name": "Marokko"
    },
    {
        "code": "MH",
        "name": "Marshalløyene"
    },
    {
        "code": "MQ",
        "name": "Martinique"
    },
    {
        "code": "MR",
        "name": "Mauretania"
    },
    {
        "code": "MU",
        "name": "Mauritius"
    },
    {
        "code": "YT",
        "name": "Mayotte"
    },
    {
        "code": "MX",
        "name": "Mexico"
    },
    {
        "code": "FM",
        "name": "Micronesia"
    },
    {
        "code": "MD",
        "name": "Moldova"
    },
    {
        "code": "MC",
        "name": "Monaco"
    },
    {
        "code": "MN",
        "name": "Mongolia"
    },
    {
        "code": "ME",
        "name": "Montenegro"
    },
    {
        "code": "MS",
        "name": "Montserrat"
    },
    {
        "code": "MPF",
        "name": "Mord Mariana Islands"
    },
    {
        "code": "MZ",
        "name": "Mozambique"
    },
    {
        "code": "MM",
        "name": "Myanmar"
    },
    {
        "code": "NA",
        "name": "Namibia"
    },
    {
        "code": "NR",
        "name": "Nauru"
    },
    {
        "code": "NL",
        "name": "Nederland"
    },
    {
        "code": "AN",
        "name": "Nederlandske Antiller"
    },
    {
        "code": "NP",
        "name": "Nepal"
    },
    {
        "code": "NZ",
        "name": "New Zealand"
    },
    {
        "code": "NI",
        "name": "Nicaragua"
    },
    {
        "code": "NE",
        "name": "Niger"
    },
    {
        "code": "NG",
        "name": "Nigeria"
    },
    {
        "code": "NU",
        "name": "Niue"
    },
    {
        "code": "KP",
        "name": "Nord Korea"
    },
    {
        "code": "NF",
        "name": "Nordfolkøya"
    },
    {
        "code": "NO",
        "name": "Norge"
    },
    {
        "code": "NC",
        "name": "Ny Kaledonia"
    },
    {
        "code": "OM",
        "name": "Oman"
    },
    {
        "code": "PK",
        "name": "Pakistan"
    },
    {
        "code": "PW",
        "name": "Palau"
    },
    {
        "code": "PS",
        "name": "Palestina"
    },
    {
        "code": "PA",
        "name": "Panama"
    },
    {
        "code": "PZ",
        "name": "Panama Kanal Zone"
    },
    {
        "code": "PG",
        "name": "Papua - Ny Guinea"
    },
    {
        "code": "PY",
        "name": "Paraguay"
    },
    {
        "code": "PE",
        "name": "Peru"
    },
    {
        "code": "PN",
        "name": "Pitcairnøye"
    },
    {
        "code": "PL",
        "name": "Polen"
    },
    {
        "code": "PT",
        "name": "Portugal"
    },
    {
        "code": "PR",
        "name": "Puerto Rico"
    },
    {
        "code": "QA",
        "name": "Qatar"
    },
    {
        "code": "RE",
        "name": "Reunion"
    },
    {
        "code": "RO",
        "name": "Romania"
    },
    {
        "code": "RU",
        "name": "Russland"
    },
    {
        "code": "RW",
        "name": "Rwanda"
    },
    {
        "code": "SB",
        "name": "Salomonøyene"
    },
    {
        "code": "WS",
        "name": "Samoa"
    },
    {
        "code": "SM",
        "name": "San Marino"
    },
    {
        "code": "ST",
        "name": "Sao Tome og Principe"
    },
    {
        "code": "SA",
        "name": "Saudi Arabia"
    },
    {
        "code": "SN",
        "name": "Senegal"
    },
    {
        "code": "CF",
        "name": "Sentralafr. republikk"
    },
    {
        "code": "RS",
        "name": "Serbia"
    },
    {
        "code": "SC",
        "name": "Seychellene"
    },
    {
        "code": "SL",
        "name": "Sierra Leone"
    },
    {
        "code": "SG",
        "name": "Singapore"
    },
    {
        "code": "SK",
        "name": "Slovakia"
    },
    {
        "code": "SI",
        "name": "Slovenia"
    },
    {
        "code": "SO",
        "name": "Somalia"
    },
    {
        "code": "ES",
        "name": "Spania"
    },
    {
        "code": "LK",
        "name": "Sri Lanka"
    },
    {
        "code": "KN",
        "name": "St. Christopher - Nevis"
    },
    {
        "code": "SH",
        "name": "St. Helena"
    },
    {
        "code": "LC",
        "name": "St. Lucia"
    },
    {
        "code": "PM",
        "name": "St. Pierre og Miquelon"
    },
    {
        "code": "VC",
        "name": "St. Vincent"
    },
    {
        "code": "GB",
        "name": "Storbritannia"
    },
    {
        "code": "SD",
        "name": "Sudan"
    },
    {
        "code": "SR",
        "name": "Suriname"
    },
    {
        "code": "SJ",
        "name": "Svalbard og Jan Mayen"
    },
    {
        "code": "CH",
        "name": "Sveits"
    },
    {
        "code": "SE",
        "name": "Sverige"
    },
    {
        "code": "SZ",
        "name": "Swaziland"
    },
    {
        "code": "SY",
        "name": "Syria"
    },
    {
        "code": "ZA",
        "name": "Sør Afrika"
    },
    {
        "code": "GS",
        "name": "Sør Georgia og S.Sandwich Isl"
    },
    {
        "code": "KR",
        "name": "Sør Korea"
    },
    {
        "code": "TJ",
        "name": "Tadzjikistan"
    },
    {
        "code": "TW",
        "name": "Taiwan"
    },
    {
        "code": "TZ",
        "name": "Tanzania"
    },
    {
        "code": "TD",
        "name": "Tchad"
    },
    {
        "code": "TH",
        "name": "Thailand"
    },
    {
        "code": "TP",
        "name": "Timor"
    },
    {
        "code": "TG",
        "name": "Togo"
    },
    {
        "code": "TK",
        "name": "Tokelau"
    },
    {
        "code": "TO",
        "name": "Tonga"
    },
    {
        "code": "TT",
        "name": "Trinidad og Tobago"
    },
    {
        "code": "CZ",
        "name": "Tsjekkia"
    },
    {
        "code": "TN",
        "name": "Tunisial"
    },
    {
        "code": "TM",
        "name": "Turkmenistan"
    },
    {
        "code": "TC",
        "name": "Turks- og Caicosøyene"
    },
    {
        "code": "TV",
        "name": "Tuvalu"
    },
    {
        "code": "TR",
        "name": "Tyrkia"
    },
    {
        "code": "DE",
        "name": "Tyskland"
    },
    {
        "code": "UG",
        "name": "Uganda"
    },
    {
        "code": "UA",
        "name": "Ukraina"
    },
    {
        "code": "HU",
        "name": "Ungarn"
    },
    {
        "code": "UY",
        "name": "Uruguay"
    },
    {
        "code": "UM",
        "name": "US. Minor Outl. Isl."
    },
    {
        "code": "US",
        "name": "USA"
    },
    {
        "code": "UZ",
        "name": "Uzbekistan"
    },
    {
        "code": "VU",
        "name": "Vanuatu"
    },
    {
        "code": "VA",
        "name": "Vatikanstaten"
    },
    {
        "code": "VE",
        "name": "Venezuela"
    },
    {
        "code": "EH",
        "name": "Vest Sahara"
    },
    {
        "code": "VN",
        "name": "Vietnam"
    },
    {
        "code": "WF",
        "name": "Wallis- og Futunaøyene"
    },
    {
        "code": "YE",
        "name": "Yemen"
    },
    {
        "code": "ZR",
        "name": "Zaire"
    },
    {
        "code": "ZM",
        "name": "Zambia"
    },
    {
        "code": "ZW",
        "name": "Zimbabwe"
    },
    {
        "code": "AT",
        "name": "Østerrike"
    },
]
